const formatTime12Hour = (time24, sessionType) => {
        if (!time24) return "";

        const [hours, minutes] = time24.split(":");
        const hour = parseInt(hours);

        if (hour >= 13) {
            const hour12 = hour - 12;
            return `${hour12}:${minutes}pm`;
        } else if (hour === 12) {
            return `12:${minutes}pm`;
        } else if (hour === 0) {
            return `12:${minutes}am`;
        } else {
            const period = sessionType === "am" ? "am" : "pm";
            return `${hour}:${minutes}${period}`;
        }
    };

   export const getTimeRange = (training_date) => {
        const firstTimeData = training_date.am?.from
            ? { time: training_date.am.from, session: "am" }
            : training_date.pm?.from
            ? { time: training_date.pm.from, session: "pm" }
            : training_date.ev?.from
            ? { time: training_date.ev.from, session: "ev" }
            : null;

        const lastTimeData = training_date.ev?.to
            ? { time: training_date.ev.to, session: "ev" }
            : training_date.pm?.to
            ? { time: training_date.pm.to, session: "pm" }
            : training_date.am?.to
            ? { time: training_date.am.to, session: "am" }
            : null;

        if (firstTimeData && lastTimeData) {
            return ` @ ${formatTime12Hour(
                firstTimeData.time,
                firstTimeData.session
            )} to ${formatTime12Hour(lastTimeData.time, lastTimeData.session)}`;
        }
        return "";
    };